var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.5 13.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #02222b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1.9,
    y1: 0.5,
    x2: 13,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1.5,
    y1: 2,
    x2: 11.6,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.5,
    y1: 3.6,
    x2: 9.3,
    y2: 3.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1.3,
    y1: 5.1,
    x2: 7.8,
    y2: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.1,
    y1: 6.6,
    x2: 7.7,
    y2: 6.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.9,
    y1: 8.1,
    x2: 8.1,
    y2: 8.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.5,
    y1: 9.7,
    x2: 8.9,
    y2: 9.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.5,
    y1: 11.2,
    x2: 9.2,
    y2: 11.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.1,
    y1: 12.7,
    x2: 8,
    y2: 12.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherFunnel);
export default __webpack_public_path__ + "static/media/icon_weather_funnel.58788a5d567ccc213445918f6d0c32a4.svg";
export { ForwardRef as ReactComponent };